<!-- eslint-disable vue/multi-word-component-names -->
<!-- 首页审稿流程 -->
<template>
    <div class="examine-container">
        <div class="title-box">
            <div class="img"><el-icon color="#409eff">
                    <Position />
                </el-icon></div>
            <div class="text01">Clear and detailed process</div>
        </div>
        <div class="step-box">
            <el-steps :active="active" simple>
                <el-step title="Paper Submission"/>
                <el-step title="Paper Review"/>
                <el-step title="Publication of papers"/>
            </el-steps>
            <el-carousel class="auto-box" arrow="always" :interval="2990" @change="autofunc">
                <el-carousel-item class="auto-item">
                    <img src="./../../public/img/step01.png">
                </el-carousel-item>
                <el-carousel-item class="auto-item">
                    <img src="./../../public/img/step02.png">
                </el-carousel-item>
                <el-carousel-item class="auto-item">
                    <img src="./../../public/img/step03.png">
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { Position } from '@element-plus/icons-vue'
let active = ref(1)
let timer = ref(null)


onMounted(() => {
    
})

// 审核状态进入下一个阶段
const autofunc = (index) =>{
    active.value = index+1
}


</script>

<style lang="scss" scoped>
.examine-container {
    .title-box {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .text01 {
            font-size: 30px;
            background-image: linear-gradient(to right, rgb(74, 92, 99), rgb(3, 79, 129));
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
        }

        .img {
            display: flex;
            align-items: center;
            margin-right: 10px;

            .el-icon {
                font-size: 30px;
            }
        }


    }

    .step-box {
        height: 300px;
        .auto-box{
            margin-top: 10px;
        }
        .auto-item {
            width: 100%;
            background-color: #f5f7fa80;
            height: 285px;
            display: flex;
            align-items: center;
            padding: 80px;
            box-sizing: border-box;
            opacity: .7;
            img {
                width: 90%;
            }
        }
    }
}
</style>